// tslint:disable
// this is an auto generated file. This will be overwritten

export const listproducts = `query Listproducts {
  listproducts {
    active
    attributes
    caption
    created
    deactivate_on
    description
    id
    metadata {
      startPath
      image
      slug
      launchPrice
    }
    images
    livemode
    name
    object
    shippable
    type
    updated
    url
    prices {
      amount
      id
      object
      active
      billing_scheme
      created
      currency
      livemode
      metadata {
        key
        value
      }
      nickname
      product
      recurring
      transform_quantity
      type
      unit_amount
      unit_amount_decimal
    }
  }
}
`;
export const getCourse = `query GetCourse($id: ID!) {
  getCourse(id: $id) {
    id
    createdAt
    updatedAt
    slug
    title
    description
    image {
      bucket
      region
      key
    }
    starterFilesLink
    price
    lectures {
      items {
        id
        createdAt
        updatedAt
        title
        video {
          bucket
          region
          key
        }
        directions {
          bucket
          region
          key
        }
        order
        course {
          id
          createdAt
          updatedAt
          slug
          title
          description
          image {
            bucket
            region
            key
          }
          starterFilesLink
          price
          lectures {
            items {
              id
              createdAt
              updatedAt
              title
              order
              owner
              lectureCourseId
              identityId
            }
            nextToken
          }
          owner
          identityId
          users {
            items {
              id
              owner
              userCourseCourseId
              currency
              source
              amount
              courseId
              invoice
            }
            nextToken
          }
        }
        owner
        lectureCourseId
        identityId
      }
      nextToken
    }
    owner
    identityId
    users {
      items {
        id
        course {
          id
          createdAt
          updatedAt
          slug
          title
          description
          image {
            bucket
            region
            key
          }
          starterFilesLink
          price
          lectures {
            items {
              id
              createdAt
              updatedAt
              title
              order
              owner
              lectureCourseId
              identityId
            }
            nextToken
          }
          owner
          identityId
          users {
            items {
              id
              owner
              userCourseCourseId
              currency
              source
              amount
              courseId
              invoice
            }
            nextToken
          }
        }
        owner
        userCourseCourseId
        currency
        source
        amount
        courseId
        invoice
      }
      nextToken
    }
  }
}
`;
export const listCourses = `query ListCourses(
  $filter: ModelCourseFilterInput
  $limit: Int
  $nextToken: String
) {
  listCourses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      updatedAt
      slug
      title
      description
      image {
        bucket
        region
        key
      }
      starterFilesLink
      price
      lectures {
        items {
          id
          createdAt
          updatedAt
          title
          video {
            bucket
            region
            key
          }
          directions {
            bucket
            region
            key
          }
          order
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          lectureCourseId
          identityId
        }
        nextToken
      }
      owner
      identityId
      users {
        items {
          id
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          userCourseCourseId
          currency
          source
          amount
          courseId
          invoice
        }
        nextToken
      }
    }
    nextToken
  }
}
`;
export const getLecture = `query GetLecture($id: ID!) {
  getLecture(id: $id) {
    id
    createdAt
    updatedAt
    title
    video {
      bucket
      region
      key
    }
    directions {
      bucket
      region
      key
    }
    order
    course {
      id
      createdAt
      updatedAt
      slug
      title
      description
      image {
        bucket
        region
        key
      }
      starterFilesLink
      price
      lectures {
        items {
          id
          createdAt
          updatedAt
          title
          video {
            bucket
            region
            key
          }
          directions {
            bucket
            region
            key
          }
          order
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          lectureCourseId
          identityId
        }
        nextToken
      }
      owner
      identityId
      users {
        items {
          id
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          userCourseCourseId
          currency
          source
          amount
          courseId
          invoice
        }
        nextToken
      }
    }
    owner
    lectureCourseId
    identityId
  }
}
`;
export const listLectures = `query ListLectures(
  $filter: ModelLectureFilterInput
  $limit: Int
  $nextToken: String
) {
  listLectures(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      updatedAt
      title
      video {
        bucket
        region
        key
      }
      directions {
        bucket
        region
        key
      }
      order
      course {
        id
        createdAt
        updatedAt
        slug
        title
        description
        image {
          bucket
          region
          key
        }
        starterFilesLink
        price
        lectures {
          items {
            id
            createdAt
            updatedAt
            title
            video {
              bucket
              region
              key
            }
            directions {
              bucket
              region
              key
            }
            order
            course {
              id
              createdAt
              updatedAt
              slug
              title
              description
              starterFilesLink
              price
              owner
              identityId
            }
            owner
            lectureCourseId
            identityId
          }
          nextToken
        }
        owner
        identityId
        users {
          items {
            id
            course {
              id
              createdAt
              updatedAt
              slug
              title
              description
              starterFilesLink
              price
              owner
              identityId
            }
            owner
            userCourseCourseId
            currency
            source
            amount
            courseId
            invoice
          }
          nextToken
        }
      }
      owner
      lectureCourseId
      identityId
    }
    nextToken
  }
}
`;
export const getUserCourse = `query GetUserCourse($id: ID!) {
  getUserCourse(id: $id) {
    id
    course {
      id
      createdAt
      updatedAt
      slug
      title
      description
      image {
        bucket
        region
        key
      }
      starterFilesLink
      price
      lectures {
        items {
          id
          createdAt
          updatedAt
          title
          video {
            bucket
            region
            key
          }
          directions {
            bucket
            region
            key
          }
          order
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          lectureCourseId
          identityId
        }
        nextToken
      }
      owner
      identityId
      users {
        items {
          id
          course {
            id
            createdAt
            updatedAt
            slug
            title
            description
            image {
              bucket
              region
              key
            }
            starterFilesLink
            price
            lectures {
              nextToken
            }
            owner
            identityId
            users {
              nextToken
            }
          }
          owner
          userCourseCourseId
          currency
          source
          amount
          courseId
          invoice
        }
        nextToken
      }
    }
    owner
    userCourseCourseId
    currency
    source
    amount
    courseId
    invoice
  }
}
`;
export const listUserCourses = `query ListUserCourses(
  $filter: ModelUserCourseFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserCourses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      course {
        id
        createdAt
        updatedAt
        slug
        title
        description
        image {
          bucket
          region
          key
        }
        starterFilesLink
        price
        lectures {
          items {
            id
            createdAt
            updatedAt
            title
            video {
              bucket
              region
              key
            }
            directions {
              bucket
              region
              key
            }
            order
            course {
              id
              createdAt
              updatedAt
              slug
              title
              description
              starterFilesLink
              price
              owner
              identityId
            }
            owner
            lectureCourseId
            identityId
          }
          nextToken
        }
        owner
        identityId
        users {
          items {
            id
            course {
              id
              createdAt
              updatedAt
              slug
              title
              description
              starterFilesLink
              price
              owner
              identityId
            }
            owner
            userCourseCourseId
            currency
            source
            amount
            courseId
            invoice
          }
          nextToken
        }
      }
      owner
      userCourseCourseId
      currency
      source
      amount
      courseId
      invoice
    }
    nextToken
  }
}
`;
export const getCoupon = `query GetCoupon($name: String!) {
  getCoupon(name: $name) {
    createdAt
    updatedAt
    courseId
    priceId
    numberLeft
    expirationDate
    name
    discountAmount
  }
}
`;
export const listCoupons = `query ListCoupons(
  $name: String
  $filter: ModelCouponFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCoupons(
    name: $name
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      createdAt
      updatedAt
      courseId
      priceId
      numberLeft
      expirationDate
      name
      discountAmount
    }
    nextToken
  }
}
`;
